import React from 'react';
import { Link } from 'react-router-dom';

const SECTIONS = [
  { id: 'terminal', label: 'Terminal' },
  { id: 'platform', label: 'Platform' },
  { id: 'features', label: 'Features' },
  { id: 'compare', label: 'Compare' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'community', label: 'Community' },
];

/* Top navigation. Section links route to /#<id> (the FlockTrade homepage) so
 * they work from the sub-pages too (LandingV2 scrolls to the hash on arrival).
 * Text anchor links are hidden < 900px (CSS); only the logo, Login and Start
 * Free Trial remain. */
export default function Nav({ brand }) {
  return (
    <nav>
      <Link to="/" className="nav-logo">
        <img className="logo-mark" src={brand.logo} alt={brand.name} />
        {brand.wordmark}
      </Link>
      <div className="nav-links">
        {SECTIONS.map((s) => (
          <Link key={s.id} to={`/#${s.id}`}>{s.label}</Link>
        ))}
        <Link to="/login" className="btn btn-ghost btn-login">Login</Link>
        <Link to="/signup?plan=professional" className="btn btn-primary">Start Free Trial</Link>
      </div>
    </nav>
  );
}
